import { Grid, InputAdornment, Typography } from "@mui/material";
import { DateTimeInput } from "components/FormControls/DateTimeInput";
import { OLCheckbox } from "components/FormControls/OLCheckbox";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { useMessage } from "hooks/intl";
import { OLPaper } from "OLPaper";
import { RewardFields } from "types/rewards";
import { pluralizeValueAdornment } from "utilities/strings";
import { useStyles } from "./RewardForm.styles";

interface Props {
  formikValues?: RewardFields & {
    autoGenerateCouponCodes?: boolean;
    specificExpiringDate?: boolean;
  };
}

export function CouponSettings({ formikValues }: Props) {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <OLPaper className={classes.OLPaper}>
      <TextInput
        className={classes.fullWidth}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {message({
                id: pluralizeValueAdornment(
                  "day",
                  formikValues?.daysInactive || 0,
                ),
              }).toLowerCase()}
            </InputAdornment>
          ),
        }}
        label={message({
          id: "numberOfDaysThisCouponWillBeInThePendingStage",
        })}
        name="daysInactive"
        type="number"
        data-test-id="reward-form-coupon-settings-days-to-activate-coupon-input"
      />
      <Grid container>
        <Grid item xs={12}>
          <TextInput
            className={classes.fullWidth}
            disabled={formikValues?.specificExpiringDate}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {message({
                    id: pluralizeValueAdornment(
                      "day",
                      formikValues?.daysValid || 0,
                    ),
                  }).toLowerCase()}
                </InputAdornment>
              ),
            }}
            label={message({ id: "daysToExpireCoupon" })}
            name="daysValid"
            type="number"
            data-test-id="reward-form-coupon-settings-days-to-expire-coupon-input"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.inputInfo}>
            {message({ id: "daysToExpireCouponInfo" })}
          </Typography>
        </Grid>
      </Grid>
      <OLCheckbox
        className={classes.zeroPadding}
        label={message({ id: "specificExpiringDate" })}
        name="specificExpiringDate"
        data-test-id="specific-expiring-date"
      />
      {formikValues?.specificExpiringDate && (
        <DateTimeInput
          width="100%"
          format="yyyy-MM-dd HH:mmXXX"
          label={
            <RequiredFieldLabel
              text={message({ id: "couponExpirationDate" })}
            />
          }
          name="dateValid"
          data-test-id="reward-form-coupon-settings-coupon-expiration-date-input"
        />
      )}
    </OLPaper>
  );
}
